<template>
    <div>
        <dv-scroll-board ref="workerStatusScroll" :config="config" style="height: 90%"/>
    </div>
</template>

<script>

import {_pxGenerator} from "@/components/LayoutMaps/maps/MapFunction";

export default {
    name: "InventoryRecordView",
    components: {},
    computed: {
        config() {
            return {
                header: ['物料', '库房', '品位', '量', '单位'],
                data: [
                    ['test', '库房', 40, 100, 't'],
                    ['test1', '库房', 40, 100, 't'],
                    ['test2', '库房1', 40, 100, 't'],
                    ['test3', '库房', 40, 100, 't'],
                    ['test4', '库房1', 40, 100, 't'],
                    ['test5', '库房2', 40, 100, 't'],
                    ['test6', '库房2', 40, 100, 't'],
                    ['test7', '库房2', 40, 100, 't'],
                    ['test8', '库房', 40, 100, 't'],
                    ['test9', '库房3', 40, 100, 't'],
                    ['test10', '库房3', 40, 100, 't'],
                ],
                index: false,
                align: ['center'],
                rowNum: 8,
                headerBGC: '#1981f6',
                headerHeight: _pxGenerator(0.6),
                oddRowBGC: 'rgba(0, 44, 81, 0.8)',
                evenRowBGC: 'rgba(10, 29, 50, 0.8)',
                hoverPause: false
            }
        }
    },
    data() {
        return {
            listData: [
                {materialName: 'test', storageName: '库房1', grade: 40, amount: 100, unit: 't'},
                {materialName: 'test1', storageName: '库房1', grade: 42, amount: 100, unit: 't'},
                {materialName: 'test2', storageName: '库房1', grade: 40, amount: 100, unit: 't'},
                {materialName: 'test3', storageName: '库房2', grade: 43, amount: 100, unit: 't'},
                {materialName: 'test4', storageName: '库房3', grade: 41, amount: 100, unit: 't'},
                {materialName: 'test5', storageName: '库房2', grade: 40, amount: 100, unit: 't'},
                {materialName: 'test6', storageName: '库房3', grade: 44, amount: 100, unit: 't'},
                {materialName: 'test7', storageName: '库房3', grade: 41.5, amount: 100, unit: 't'},
                {materialName: 'test7', storageName: '库房3', grade: 41.5, amount: 100, unit: 't'},
                {materialName: 'test7', storageName: '库房3', grade: 41.5, amount: 100, unit: 't'},
                {materialName: 'test7', storageName: '库房3', grade: 41.5, amount: 100, unit: 't'},
                {materialName: 'test7', storageName: '库房3', grade: 41.5, amount: 100, unit: 't'},
                {materialName: 'test7', storageName: '库房3', grade: 41.5, amount: 100, unit: 't'},
                {materialName: 'test7', storageName: '库房3', grade: 41.5, amount: 100, unit: 't'},
                {materialName: 'test7', storageName: '库房3', grade: 41.5, amount: 100, unit: 't'},
            ],
            fields: [
                {key: 'materialName', label: '物料'},
                {key: 'storageName', label: '库房'},
                {key: 'grade', label: '品位'},
                {key: 'amount', label: '量'},
                {key: 'unit', label: '单位'},
            ],
        }
    }
}
</script>

<style scoped>

</style>